<!-- profile-settings.component.html -->
<div class="settings-header">
  <h1>Settings</h1>
  <p-tabView>
    <p-tabPanel header="Profile">
      <div class="personal-info">
        <h3>Personal info</h3>
        <p>Update your personal details here.</p>
      </div>
      <hr class="custom-hr" />

      <div *ngIf="isProfileLoaded; else loadingTemplate">
        <form [formGroup]="form" (ngSubmit)="onSubmit()">
          <formly-form
            [form]="form"
            [fields]="fields"
            [model]="model"
            [options]="options"
          ></formly-form>
          <div class="button-group">
            <button
              pButton
              type="button"
              label="Cancel"
              class="cancel-button"
              (click)="onCancel()"
            ></button>
            <button
              pButton
              type="submit"
              label="Save"
              class="p-button-warning save-button btn-primary"
            ></button>
          </div>
        </form>
      </div>
      <!-- Loading Placeholder -->
      <ng-template #loadingTemplate>
        <p>Loading profile details...</p>
      </ng-template>
    </p-tabPanel>
    <p-tabPanel header="Password">
      <!-- Password update logic can be implemented here -->
      <app-password></app-password>
    </p-tabPanel>
  </p-tabView>
</div>
